import { render, staticRenderFns } from "./ButtonRounded.vue?vue&type=template&id=7394c9a0"
import script from "./ButtonRounded.vue?vue&type=script&lang=js"
export * from "./ButtonRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports